import { NumberBox, TextBox, Tooltip } from 'devextreme-react';
import React, { useCallback, useMemo, useState } from 'react';
Number.prototype.toTimeString = function () {

  var ms = this,
    endPos = ~(1);  // to trim "Z" or ".sssZ"

  if (ms < 60000) {
    var timeString = new Date(ms).toISOString().slice(17, endPos); //nur Sekunden
  } else
    if (ms < 600000) {
      var timeString = new Date(ms).toISOString().slice(15, endPos); // Minuten Einstellig
    } else
      if (ms < 3600000) {
        var timeString = new Date(ms).toISOString().slice(14, endPos); // Minuten Zweistellig
      } else {
        var timeString = new Date(ms).toISOString().slice(12, endPos); // Stunden
      }
  return timeString;
};
export const TimeBox = ({ text, contentClass = '', showText = true }) => {
  return (
    <div>
      <span>{text != "" ? Number(text).toTimeString() : ''}</span>
    </div>)
};
export const TimeBoxBold = ({ text, contentClass = '', showText = true }) => {
  return (
    <div>
      <span><b>{text != "" ? Number(text).toTimeString() : ''}</b></span>
    </div>)
};
const rules = {
  H: char => char >= 0 && char <= 1,
  M: char => char >= 0 && char <= 5,
  m: char => char >= 0 && char <= 9,
  S: char => char >= 0 && char <= 9,
  s: char => char >= 0 && char <= 9
};
export const EditCellTimeComponent = (props) => {

  const [value, setValue] = useState(props.data.value > 0 ? props.data.value.toTimeString() : '');

  const onValueChanged = useCallback(
    (e) => {
      let inputValue = e.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
      if (inputValue.length > 2) {
        inputValue = inputValue.slice(0, inputValue.length - 2) + ',' + inputValue.slice(inputValue.length - 2);
      }
      if (inputValue.length > 5) {
        inputValue = inputValue.slice(0, inputValue.length - 5) + ':' + inputValue.slice(inputValue.length - 5);
      }
      if (inputValue.length > 8) {
        inputValue = inputValue.slice(0, inputValue.length - 8) + ':' + inputValue.slice(inputValue.length - 8);
      }
      setValue(inputValue);
      // Convert formatted time string to milliseconds
      const parts = inputValue.split(/[:,]/);
      let milliseconds = 0;
      if (parts.length === 4) {
        milliseconds = (+parts[0] * 3600000) + (+parts[1] * 60000) + (+parts[2] * 1000) + (+parts[3] * 10);
      } else if (parts.length === 3) {
        milliseconds = (+parts[0] * 60000) + (+parts[1] * 1000) + (+parts[2] * 10);
      } else if (parts.length === 2) {
        milliseconds = (+parts[0] * 1000) + (+parts[1] * 10);
      } else if (parts.length === 1) {
        milliseconds = (+parts[0] * 10);
      }
      props.data.setValue(milliseconds);
    },
    [props],
  );

  return (
    <TextBox
      value={value}
      onValueChanged={onValueChanged}
      valueChangeEvent='keyup'
      mode='tel'
    />
  );
};
export const EditFormTimeComponent = ({ value, onValueChange, label, stylingMode }) => {
  const [localValue, setLocalValue] = useState(
    value > 0 ? Number(value).toTimeString() : ''
  );

  const handleValueChanged = useCallback(
    (e) => {

      let inputValue = e.replace(/[^0-9]/g, ''); // Entferne nicht-numerische Zeichen
      if (inputValue.length > 2) {
        inputValue =
          inputValue.slice(0, inputValue.length - 2) +
          ',' +
          inputValue.slice(inputValue.length - 2);
      }
      if (inputValue.length > 5) {
        inputValue =
          inputValue.slice(0, inputValue.length - 5) +
          ':' +
          inputValue.slice(inputValue.length - 5);
      }
      if (inputValue.length > 8) {
        inputValue =
          inputValue.slice(0, inputValue.length - 8) +
          ':' +
          inputValue.slice(inputValue.length - 8);
      }

      setLocalValue(inputValue);
      // Konvertiere die formatierte Zeitzeichenkette in Millisekunden
      const parts = inputValue.split(/[:,]/);
      let milliseconds = 0;
      if (parts.length === 4) {
        milliseconds =
          +parts[0] * 3600000 +
          +parts[1] * 60000 +
          +parts[2] * 1000 +
          +parts[3] * 10;
      } else if (parts.length === 3) {
        milliseconds =
          +parts[0] * 60000 + +parts[1] * 1000 + +parts[2] * 10;
      } else if (parts.length === 2) {
        milliseconds = +parts[0] * 1000 + +parts[1] * 10;
      } else if (parts.length === 1) {
        milliseconds = +parts[0] * 10;
      }

      // Rufe die übergebene onValueChanged-Funktion auf
       onValueChange(milliseconds);
    },
    []
  );

  return (
    <TextBox
      value={localValue}
      onValueChange={handleValueChanged}
      valueChangeEvent="keyup"
      mode="tel"
      stylingMode={stylingMode}
      label={label}
    />
  );
};


